import { render, staticRenderFns } from "./InvestmentRecommendDet.vue?vue&type=template&id=5fd436f3&scoped=true"
import script from "./InvestmentRecommendDet.vue?vue&type=script&lang=js"
export * from "./InvestmentRecommendDet.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=5fd436f3&prod&scoped=true&lang=css&external"
import style1 from "../InvestmentRecommend/InvestmentRecommend.less?vue&type=style&index=1&id=5fd436f3&prod&lang=less&scoped=true&external"
import style2 from "./InvestmentRecommendDet.vue?vue&type=style&index=2&id=5fd436f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd436f3",
  null
  
)

export default component.exports